import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { MetaModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { CompanyMentorGridDataService } from 'common/services/data-services/admin/internship-company/internship-company-mentor-grid-data.service';
import { CompanyMentorModel } from 'common/models/page-models/internship-company/company-mentor/company-mentor-data.model';
import { CompanyMentorGridMetaModel } from 'common/models/page-models/internship-company/company-mentor/company-mentor-grid-meta.model';
import { CompanyMentorListingModel } from 'common/models/page-models/internship-company/company-mentor/company-mentor-grid.model';




@Injectable({
    providedIn: 'root'
})
export class CompanyMentorGridWidgetService extends GridWidgetService<CompanyMentorModel, CompanyMentorListingModel> {
    constructor(protected override ds: CompanyMentorGridDataService, protected systemService: SystemService) {
        super(ds);
    }


    getMetaModel(): MetaModel {
        const meta = new CompanyMentorGridMetaModel().getMetaModel();
        
        return meta;
    }
   


}